import { createContext, useContext } from "react";

import { BudgetSpend } from "@models/Budget";

type OrderSetBudgetSpendContextType =
  | {
      budgetSpends: Record<string, BudgetSpend>;
      isPending: false;
      isFetching: boolean;
    }
  | {
      budgetSpends: null;
      isPending: true;
      isFetching: boolean;
    };

export const OrderSetBudgetSpendContext =
  createContext<OrderSetBudgetSpendContextType | null>(null);

export const useOrderSetBudgetSpend = () => {
  const context = useContext(OrderSetBudgetSpendContext);
  if (!context) {
    throw new Error(
      "useOrderSetBudgetSpend must be used within an OrderSetBudgetSpendProvider"
    );
  }
  return context;
};
